import $script from 'scriptjs';
import axios from 'axios';
import { triggerCustomEvent, featureEnabled } from 'lib/helpers';
import Cookies from 'js-cookie';

import {
  socialSessionLoading,
  socialSessionError,
  socialSessionRedirect,
} from 'lib/social-session-helpers';

export default class FacebookLogin {
  constructor({
    buttonTarget, textTarget = null, csrfToken, omniauthToken,
  }) {
    this.buttonTarget = buttonTarget;
    this.textTarget = textTarget;
    this.csrfToken = csrfToken;
    this.omniauthToken = omniauthToken;

    this.init();
  }

  init() {
    socialSessionError(false, this.buttonTarget);

    this.authType = 'reauthorize';

    $script('https://connect.facebook.net/en_US/sdk.js', this.loadFacebookApi);
  }

  loadFacebookApi = () => {
    window.FB.init({
      appId: this.buttonTarget.dataset.appId,
      autoLogAppEvents: true,
      cookie: true,
      status: true,
      xfbml: false,
      version: 'v3.2',
    });
  }

  connect() {
    const newsletter = document.getElementById('user_newsletter');
    let newsletterValue = false;
    if (newsletter !== null && newsletter.type !== 'hidden') {
      newsletterValue = newsletter.checked;
    } else if (newsletter !== null && newsletter.type === 'hidden') {
      newsletterValue = true;
    }

    if (featureEnabled('editor2') && Cookies.get('login_in_place')) {
      const { omniauthPath } = this.buttonTarget.dataset;
      const url = `${omniauthPath}/callback?newsletter=${newsletterValue}&state=${this.omniauthToken}`;
      this.buttonTarget.dataset.omniauthPath = url;
    } else {
      this.buttonTarget.dataset.omniauthPath = `${this.buttonTarget.dataset.omniauthPath}?newsletter=${newsletterValue}`;
    }

    if (this.textTarget) {
      this.originalText = this.textTarget.innerHTML;

      socialSessionLoading(this.buttonTarget);
    }

    this.login().then(
      () => {
        this.validate().then(
          this.loginResolve,
          () => {
            this.loginReject(true);
          },
        );
      },
      this.loginReject,
    );
  }

  loginResolve = () => {
    if (featureEnabled('editor2') && Cookies.get('login_in_place')) {
      this.axiosLoginCall();
    } else {
      socialSessionRedirect(this.buttonTarget,
        this.csrfToken,
        this.buttonTarget.dataset.omniauthPath);
    }
  }

  axiosLoginCall() {
    axios.defaults.headers.common['X-CSRF-Token'] = this.csrfToken;
    axios.post(this.buttonTarget.dataset.omniauthPath).then((req) => {
      if (req.data.message === 'login_in_place') {
        triggerCustomEvent('LoggedInPlace');
      }
    });
  }

  loginReject = (error = false) => {
    if (this.textTarget) socialSessionLoading(this.buttonTarget, this.originalText);
    socialSessionError(error, this.buttonTarget);

    if (error) this.authType = 'rerequest';
  }

  login() {
    return new Promise((resolve, reject) => {
      window.FB.login(
        (response) => {
          if (response.status === 'connected') {
            resolve();
          } else {
            reject();
          }
        },
        { scope: 'public_profile,email', auth_type: this.authType },
      );
    });
  }

  validate() {
    return new Promise((resolve, reject) => {
      window.FB.api('/me/permissions', (response) => {
        response.data.forEach((permission) => {
          if (
            permission.permission === 'email'
            && permission.status !== 'granted'
          ) {
            reject();
          }

          if (
            permission.permission === 'public_profile'
            && permission.status !== 'granted'
          ) {
            reject();
          }
        });

        resolve();
      });
    });
  }
}
